module.exports = __webpack_public_path__ + "img/icon_slogo_home.fa65596f.png";